import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const GetAgenda = async (trackingCode) => {
  try {
    const response = await fetch("https://frabas.cl/backend/pago.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ codigo: trackingCode })
    });

    const data = await response.json();
    if (data.success) {
      return data.data;
    }
  } catch (error) {
    console.error("Error al obtener datos de agenda:", error);
    return [];
  }
};

const Payments = () => {
  const { trackingCode } = useParams();

  const [user, setUsuario] = useState(null);
  const [pagos, setPagos] = useState([]);

  const [formData, setFormData] = useState({
    nombreCompleto: '',
    numeroTarjeta: '',
    cvv: '',
    fechaVencimiento: '',
    codigo: trackingCode,
    mail: '',
  });
  
  // Cargar datos del usuario desde localStorage
  useEffect(() => {
    const datosUsuario = JSON.parse(localStorage.getItem('datosUsuario'));
    if (datosUsuario) {
      try {
        setUsuario(datosUsuario);
      } catch (error) {
        console.error('Error al parsear el usuario:', error);
      }
    }
  }, []);


  // Una vez que el usuario se carga, actualiza el mail en formData
  useEffect(() => {
    if (user?.mail) {
      setFormData((prev) => ({
        ...prev,
        mail: user.mail
      }));
    }
  }, [user]);

  // Obtener datos de agenda
  useEffect(() => {
    const fetchData = async () => {
      if (!trackingCode) return;
      const data = await GetAgenda(trackingCode);
      setPagos(data || []);
    };
    fetchData();
  }, [trackingCode]);

  // Manejo de formulario
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };

  const marcarComoPagado = async () => {
    const response = await fetch("https://frabas.cl/backend/pagado.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify( formData )
      
      
    });
    console.log(formData)
    const result = await response.json();
    if (result.success) {
      console.log('todo bn')

      alert("Estado actualizado a pagado");
    } else {
      console.log('error')
      alert("Error: " + result.message);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative bg-[#8B0000] text-white py-20">
        <div className="absolute inset-0 bg-black opacity-20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Proceso de Pago</h1>
          <p className="text-xl md:text-2xl">Complete los detalles de pago para finalizar su compra</p>
        </div>
      </div>

      {/* Contenido Principal */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Formulario de Pago */}
          <div className="bg-white rounded-xl shadow-lg p-8">
            <h2 className="text-3xl font-bold text-[#8B0000] mb-6">Detalles del Pago</h2>
            <div className="mb-6 p-4 bg-gray-100 rounded-lg">
              <p className="text-gray-700">Código de Seguimiento: <span className="font-bold">{trackingCode}</span></p>
            </div>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-gray-700 font-medium mb-2">Nombre Completo</label>
                <input
                  type="text"
                  name="nombreCompleto"
                  value={formData.nombreCompleto}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8B0000] focus:border-[#8B0000]"
                  required
                  placeholder="Ej: Juan Pérez González"
                />
              </div>

              <div>
                <label className="block text-gray-700 font-medium mb-2">Número de Tarjeta</label>
                <input
                  type="number"
                  name="numeroTarjeta"
                  value={formData.numeroTarjeta}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8B0000] focus:border-[#8B0000]"
                  required
                  placeholder="XXXX XXXX XXXX XXXX"
                  maxLength="19"
                />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-gray-700 font-medium mb-2">CVV</label>
                  <input
                    type="password"
                    name="cvv"
                    value={formData.cvv}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8B0000] focus:border-[#8B0000]"
                    required
                    placeholder="XXX"
                    maxLength="3"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-medium mb-2">Fecha de Vencimiento</label>
                  <input
                    type="text"
                    name="fechaVencimiento"
                    value={formData.fechaVencimiento}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8B0000] focus:border-[#8B0000]"
                    required
                    placeholder="MM/AA"
                    maxLength="5"
                  />
                </div>
              </div>

              <button
                type="submit"
                onClick={marcarComoPagado}
                className="w-full bg-[#8B0000] text-white py-3 px-6 rounded-lg font-medium hover:bg-[#A52A2A] transition-colors duration-300"
              >
                Realizar Pago
              </button>
            </form>
          </div>

          {/* Información de Seguridad */}
          <div className="space-y-8">
            <div className="bg-white rounded-xl shadow-lg p-8">
              <h2 className="text-3xl font-bold text-[#8B0000] mb-6">Pago Seguro</h2>
              <div className="space-y-4">
                {/* Seguridad UI: omitido aquí por espacio, puedes conservar el tuyo como estaba */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Payments;
